'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _PropertyBag2 = require('../Core/PropertyBag');

var _PropertyBag3 = _interopRequireDefault(_PropertyBag2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 *
 * @type {string}
 */
var paramPrefix = 'dp.';

/**
 * @ignore
 *
 * @type {{dpXconfTag: string, dpWidgetId: string}}
 */
var propNamesMap = {
  dpXconfTag: 'dp.xconf.tag',
  dpWidgetId: 'dp.widgetId'
};

/**
 * @ignore
 *
 * @param {String} str
 * @return {void|*|string|XML}
 */
var toPropName = function toPropName(str) {
  var replace = function replace(match) {
    return match.charAt(1).toUpperCase() + match.substr(2);
  };
  return str.replace(/[.](\w|$)/g, replace);
};

/**
 * @ignore
 * @private
 *
 * @param {String} str
 * @return {string}
 */
var toParamName = function toParamName(str) {
  return paramPrefix + str.replace(/([a-z\d])([A-Z])/g, '$1' + '.' + '$2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + '.' + '$2').toLowerCase();
};

/**
 * @ignore
 *
 * @param {String} qs
 * @return {*}
 */
var parseQueryString = function parseQueryString(qs) {
  "use strict";

  var props = {};

  var queryParams = qs.split('&').map(function (nameAndValue) {
    return nameAndValue.split('=');
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(queryParams), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var param = _step.value;

      var _param = (0, _slicedToArray3.default)(param, 2),
          name = _param[0],
          value = _param[1];

      if (name.substr(0, paramPrefix.length) === paramPrefix) {
        var propName = toPropName(name);
        props[propName] = decodeURIComponent(value);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return props;
};

/**
 * @ignore
 * @private
 *
 * @param props
 * @return {*}
 */
var encodeAsQueryString = function encodeAsQueryString(props) {
  "use strict";

  var reducer = function reducer(acc, key) {
    var paramKey = toParamName(key);
    var paramValue = encodeURIComponent(props[key]);

    return acc + (acc === '' ? '' : '&') + (paramKey + '=' + paramValue);
  };

  return (0, _keys2.default)(props).reduce(reducer, '');
};

/**
 * @class
 */

var InitPropertiesBag = function (_PropertyBag) {
  (0, _inherits3.default)(InitPropertiesBag, _PropertyBag);
  (0, _createClass3.default)(InitPropertiesBag, null, [{
    key: 'validate',

    /**
     * @param {*|InitPropertiesBag} propsOrInstance
     * @return {boolean}
     */
    value: function validate(propsOrInstance) {
      if (propsOrInstance && (typeof propsOrInstance === 'undefined' ? 'undefined' : (0, _typeof3.default)(propsOrInstance)) === 'object') {
        var dpWidgetId = propsOrInstance.dpWidgetId;


        return dpWidgetId && typeof dpWidgetId === 'string' && dpWidgetId != '';
      }

      return false;
    }

    /**
     * @param {string} queryString
     * @return {InitPropertiesBag|null}
     */

  }, {
    key: 'fromQueryString',
    value: function fromQueryString(queryString) {
      var initParams = parseQueryString(queryString);
      if (InitPropertiesBag.validate(initParams)) {
        return new InitPropertiesBag(initParams);
      }

      return null;
    }

    /**
     * @param {Window} windowObject
     * @return {InitPropertiesBag}
     */

  }, {
    key: 'fromWindow',
    value: function fromWindow(windowObject) {
      var location = windowObject.location;

      // build a list of potential sources for init params, ordered by priority

      var paramsQueryStrings = [location.hash.length ? location.hash.substring(1) : null, location.search.length ? location.search.substring(1) : null].filter(function (string) {
        return !!string;
      });

      if (paramsQueryStrings.length === 0) {
        return null;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(paramsQueryStrings), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var queryString = _step2.value;

          var initParams = InitPropertiesBag.fromQueryString(queryString);
          if (initParams) {
            return initParams;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    }

    /**
     * @param {string} dpXconfTag
     * @param {string} dpWidgetId
     * @param rest
     */

  }, {
    key: 'PARAM_PREFIX',

    /**
     * @type {string}
     */
    get: function get() {
      return paramPrefix;
    }
  }, {
    key: 'PROP_NAMES',


    /**
     * @type {{dpXconfTag: string, dpWidgetId: string}}
     */
    get: function get() {
      return propNamesMap;
    }
  }]);

  function InitPropertiesBag(_ref) {
    var dpXconfTag = _ref.dpXconfTag,
        dpWidgetId = _ref.dpWidgetId,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['dpXconfTag', 'dpWidgetId']);
    (0, _classCallCheck3.default)(this, InitPropertiesBag);
    return (0, _possibleConstructorReturn3.default)(this, (InitPropertiesBag.__proto__ || (0, _getPrototypeOf2.default)(InitPropertiesBag)).call(this, (0, _extends3.default)({ dpXconfTag: dpXconfTag, dpWidgetId: dpWidgetId }, rest)));
  }

  /**
   * @deprecated
   *
   * @type {String}
   */


  (0, _createClass3.default)(InitPropertiesBag, [{
    key: 'toQueryString',


    /**
     * @method
     *
     * @return {string}
     */
    value: function toQueryString() {
      return encodeAsQueryString(this.props);
    }
  }, {
    key: 'dpXconfTag',
    get: function get() {
      return this.props.dpXconfTag;
    }

    /**
     * @type {string}
     */

  }, {
    key: 'dpWidgetId',
    get: function get() {
      return this.props.dpWidgetId;
    }
  }]);
  return InitPropertiesBag;
}(_PropertyBag3.default);

exports.default = InitPropertiesBag;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Widget/InitPropertiesBag.js
// module id = 300
// module chunks = 0